import React from 'react'
import classNames from 'classnames'
import moment from 'moment'
import _ from 'lodash'


import {HashTag} from '../services/hashtag'


export class ChatItem extends React.Component {
    constructor(props) {
        super(props)
    }

    deepLink() {
        let hashtag = HashTag.parse(this.props.message.get('hashtag'))
        if (_.isNull(hashtag)) {
            return null
        }

        let follow = () => {
            this.props.onLoadHashtag(hashtag)
        }

        return (
            <div className="chat-item-deeplink">
                <a onClick={follow}>View details</a>
            </div>
        )
    }

    displayDeepLink() {
        if (this.props.msgDelta.showHash) {
            return this.deepLink()
        }
    }

    displayTimestamp() {
        if (this.props.msgDelta.showTime) {
            return (
                <div className="chat-item-time">
                    {moment(this.props.message.get('created_at')).format('MMM D, h:mm A')}
                </div>
            )
        }
    }


    displayUserIcon() {
        if (this.props.msgDelta.showUser && this.props.user.get('firstname') == 'LUNA' && this.props.user.get('lastname') == 'PLANNER') {
            return (
                <div className={'chat-item-head left'}>
                    <div className="blue">
                        <i className="icon-diamond" style={{fontSize: '2em'}}/>
                    </div>
                </div>
            )
        } else if (this.props.msgDelta.showUser) {
            return (
                <div className={'chat-item-head ' + (this.props.isMe ? 'right' : 'left')}>
                    <div className="user-icon purple">
                        {this.props.user.get('firstname').slice(0, 1) + this.props.user.get('lastname').slice(0, 1)}
                    </div>
                </div>
            )
        }
    }

    displayMessage() {
        let hasMention = this.props.message.get('mentions')
        // TODO: Eventually we want to look for other taks items which may or may not need to be removed from the message text
        let message = this.props.message.get('message').replace('/force', '')
        let showLink = this.props.message.get('message').indexOf('/link') > -1
        message = message.replace('/link', '')

        let getDeepLink = () => {
            if (showLink)
                return this.deepLink()
        }

        let formattedMessage = () => {
            if (hasMention.size == 1) {
                let index = hasMention.getIn([0, 'mention_index'])
                return (
                    <div>
                        {message.substr(0, index)}
                        <strong>@luna</strong>
                        {message.substr(index + 5)}
                    </div>
                )
            }
            return (<div>{message}</div>)
        }

        return (
            <div className={'chat-item-body '
            + (this.props.isMe ? 'left ' : 'right ')
            + (this.props.msgDelta.showUser ? ' ' : 'shift-up ')}>
                {formattedMessage()}
                {getDeepLink()}
            </div>
        )
    }

    displayFooter() {
        return (<div/>)
        /* <div className="chat-item-foot">
          <div>
            <a href="#" onClick={activateLeg}>{message.get('hashtag')}</a>
          </div>
          <div>
            {moment(message.get('created_at')).format('hh:mm A MMM D')}
          </div>
        </div>*/
    }

    render() {
        return (
            <div className="chat-item clearfix">
                {this.displayDeepLink()}
                {this.displayTimestamp()}
                {this.displayUserIcon()}
                {this.displayMessage()}
                {this.displayFooter()}
            </div>
        )
    }
}